import { useState } from 'react';
import { usePatternContext } from '../../../../context/PatternContext';
import { s } from './Result.styles';
import SaveModal from './SaveModal';
import {
  MarketPriceEstimationData,
  AppraisalPointData,
  NumberOfFailedBidData,
  OldAgeData,
  SalesDaysData,
} from '../data';
import styled from 'styled-components';

interface Props {
  isSaved?: boolean;
  page?: string;
  setIsEditMode?: (value: boolean) => void;
}
const SelectedPattern = ({ isSaved, page, setIsEditMode }: Props) => {
  const [openPattern, setOpenPattern] = useState(true);
  const [showSaveModal, setShowSaveModal] = useState(false);
  const { setIsAnalysisDone, patternInfo } = usePatternContext();
  const [isSaveDone, setIsSaveDone] = useState(false);
  const specailPatternInfo = {
    'HUG인수 조건변경': patternInfo.hug,
    '임차인 대항력': patternInfo.opposing_power,
    임금채권: patternInfo.wage_bond,
    재매각: patternInfo.resale,
    위반건축물: patternInfo.violation_building,
    법정지상권: patternInfo.statutory_superficies,
    분묘기지권: patternInfo.tomb_base_right,
    유치권: patternInfo.lien,
  };

  const ChangeLabelToValue = (value: string, data: any) => {
    const newValue = data.find((item: any) => item.value === value)?.label;
    return newValue ?? '';
  };

  return (
    <Container>
      <PatternContainer>
        <PatternInner isOpen={openPattern}>
          <AlgorithmBox>
            <AlgorithmTitleBox>
              <AlgorithmTitle>
                <img
                  src="/assets/images/icon/check-on.svg"
                  alt=""
                  style={{ width: '22px', height: '22px' }}
                />
                <div>분석 기준</div>
              </AlgorithmTitle>
              <div>{page !== 'result' ? <span>변경</span> : ''}</div>
            </AlgorithmTitleBox>
            <SelectedPatternPatternBox>
              <SelectedItem>
                {patternInfo.ctp}
                {patternInfo.sig === null ? '' : `>${patternInfo.sig}`}
                {patternInfo.emd === null ? '' : `>${patternInfo.emd}`}
              </SelectedItem>
              {typeof patternInfo.item_category === 'string' &&
                patternInfo.item_category
                  .split(',')
                  .map((item) => (
                    <SelectedItem key={item}>{item}</SelectedItem>
                  ))}
              <SelectedItem>
                {patternInfo.start_date}~{patternInfo.end_date}
              </SelectedItem>
              {typeof patternInfo.zoning === 'string' &&
                patternInfo.zoning
                  .split(',')
                  .map((item) => (
                    <SelectedItem key={item}>{item}</SelectedItem>
                  ))}
            </SelectedPatternPatternBox>
          </AlgorithmBox>
          {/*  핵심 알고리즘 */}
          <AlgorithmBox>
            <AlgorithmTitleBox>
              <AlgorithmTitle>
                <img src="/assets/images/icon/check-on.svg" />
                <div>핵심 알고리즘</div>
              </AlgorithmTitle>
              <div>{page !== 'result' ? <span>변경</span> : ''}</div>
            </AlgorithmTitleBox>
            <SelectedPatternPatternBox>
              {patternInfo.margin !== 'A' && (
                <SelectedItem>
                  {patternInfo.margin === 'Y'
                    ? `차익有(낙찰가<매각가)`
                    : patternInfo.margin === 'N'
                      ? `차익無(낙찰가>매각가)`
                      : ''}
                </SelectedItem>
              )}
              {patternInfo.hidden_value !== 'A' && (
                <SelectedItem>
                  {patternInfo.hidden_value === 'L'
                    ? `저평가 (시세>감정가)`
                    : patternInfo.hidden_value === 'H'
                      ? `고평가 (시세<감정가)`
                      : ''}
                </SelectedItem>
              )}
              <SelectedItem>
                {patternInfo.profit === 'Y'
                  ? '부대비용 포함'
                  : '부대비용 미포함'}
              </SelectedItem>
              {patternInfo?.market_prc !== 'A' && (
                <SelectedItem>
                  {ChangeLabelToValue(
                    patternInfo.market_prc,
                    MarketPriceEstimationData,
                  )}
                </SelectedItem>
              )}
              {patternInfo.appraisal_point !== 'A' && (
                <SelectedItem>
                  {ChangeLabelToValue(
                    patternInfo.appraisal_point,
                    AppraisalPointData,
                  )}
                </SelectedItem>
              )}
              {patternInfo.bid_cnt !== 'A' && (
                <SelectedItem>
                  {ChangeLabelToValue(
                    patternInfo.bid_cnt,
                    NumberOfFailedBidData,
                  )}
                </SelectedItem>
              )}
              {patternInfo.elapsed_years !== 'A' && (
                <SelectedItem>
                  {ChangeLabelToValue(patternInfo.elapsed_years, OldAgeData)}
                </SelectedItem>
              )}
              {patternInfo.sale_days !== 'A' && (
                <SelectedItem>
                  {ChangeLabelToValue(patternInfo.sale_days, SalesDaysData)}
                </SelectedItem>
              )}
              {patternInfo.investment_rate && (
                <SelectedItem>
                  {patternInfo.investment_rate !== null &&
                    `낙찰가의 ${patternInfo.investment_rate}%`}
                </SelectedItem>
              )}
            </SelectedPatternPatternBox>
          </AlgorithmBox>
          {/* 특수 알고리즘 */}
          <AlgorithmBox>
            <AlgorithmTitleBox>
              <AlgorithmTitle>
                <img src="/assets/images/icon/check-on.svg" />
                <div>특수 알고리즘</div>
              </AlgorithmTitle>
              <div>{page !== 'result' ? <span>변경</span> : ''}</div>
            </AlgorithmTitleBox>
            <SelectedPatternPatternBox>
              {Object.entries(specailPatternInfo).map(([key, value]) => (
                <>
                  {value !== 'A' && (
                    <SelectedItem key={key}>
                      {' '}
                      {value === 'Y' ? (
                        <span>{`${key}> 선택`}</span>
                      ) : (
                        <>
                          <span>{`${key}> `}</span>
                          <span style={{ color: '#F45551' }}>제외</span>
                        </>
                      )}
                    </SelectedItem>
                  )}
                </>
              ))}
            </SelectedPatternPatternBox>
          </AlgorithmBox>
          <SelectedPatternBottomButtonBox>
            {/* {page === 'result' ? (
              <s.NextButton
                onClick={() => {
                  setIsEditMode && setIsEditMode(true);
                }}
              >
                수정하기
              </s.NextButton>
            ) : (
              <s.NextButton
                onClick={() => {
                  setIsEditMode && setIsEditMode(true);
                  setIsAnalysisDone && setIsAnalysisDone(false);
                }}
              >
                수정하기
              </s.NextButton>
            )} */}
            {!isSaveDone && page !== 'result' ? (
              <s.AnalyzeButton
                style={{
                  width: '100%',
                }}
                onClick={() => {
                  setShowSaveModal(true);
                }}
              >
                알고리즘 저장
              </s.AnalyzeButton>
            ) : (
              <s.SaveDoneButton
                style={{
                  width: '100%',
                }}
              >
                저장완료
              </s.SaveDoneButton>
            )}
          </SelectedPatternBottomButtonBox>
        </PatternInner>
        <s.ShowMoreButton
          onClick={() => setOpenPattern(!openPattern)}
          style={{
            borderTop: openPattern ? 'none' : '1px solid #e5e8ea',
            borderRadius: openPattern ? '0 0 12px 12px' : '12px',
          }}
        >
          <span>{openPattern ? '알고리즘조건 닫기' : '알고리즘조건 열기'}</span>
          <img
            src={`/assets/images/arrow/${openPattern ? 'arrow-up-989ba2' : 'arrow-down-989ba2'}.svg`}
            alt=""
            style={{ width: '16px', height: '16px' }}
          />
        </s.ShowMoreButton>
        {showSaveModal && (
          <SaveModal
            isSaveDone={isSaveDone}
            setIsSaveDone={setIsSaveDone}
            setShowSaveModal={setShowSaveModal}
          />
        )}
      </PatternContainer>
    </Container>
  );
};

export default SelectedPattern;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
`;

const AlgorithmTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const AlgorithmTitleBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  color: #222222;
  font-size: 16px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 23.2px;
  word-wrap: break-word;
  span {
    color: #616161;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;

const AlgorithmBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

interface PatternProps {
  isOpen: boolean;
}
const PatternContainer = styled.div`
  position: relative;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
  background-color: #fff;
`;

const PatternInner = styled.div<PatternProps>`
  width: 100%;
  display: ${(props) => (props.isOpen ? 'flex' : 'none')} !important;
  padding: 24px 16px;
  gap: 24px;
  display: flex;
  flex-direction: column;
  // border-radius: 16px;
  // border: 1px solid #e5e8ea;
`;

const SelectedPatternBottomButtonBox = styled(s.BottomButtonBox)`
  padding: 0;
  border: none;
  height: auto;
  justify-content: space-between;
`;

const SelectedPatternPatternBox = styled(s.PatternBox)`
  width: 100%;
  height: 100%;
  border: none;
  padding: 12px;
  border: 1px solid #e5e8ea;
  border-radius: 8px;
  gap: 6px;
`;

const SelectedItem = styled.span`
  // width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 4px 8px;
  border: 1px solid #e5e8ea;
  border-radius: 8px;
  background-color: rgba(112, 115, 124, 0.05);
`;
